<!-- // 重点澄清页面开发 -->
<template>
  <div class="EmphasisClarification CommonContentSingle-gray">
    <el-dialog title="测试报告" :visible.sync="centerDialogVisible" width="50%" center>
      <div style="background: rgba(225, 245, 233, 1);height: 40px;line-height: 40px;">
        <span style="margin-left: 20px; font-size: 14px; font-weight: 400;">{{ $t('original.name') }}：{{ Paperhead.Name
        }}</span>
        <span style="margin-left: 20px; font-size: 14px; font-weight: 400;"> {{ $t('original.gender') }}：{{ Paperhead.Sex
        }}</span>
        <span style="margin-left: 20px; font-size: 14px; font-weight: 400;"> {{ $t('original.Name_of_Company') }}：{{
          Paperhead.DeptName }}</span>
      </div>
      <table style="width: 100%;" class="Paperhead">
        <tr style="width: 100%;height: 40px;line-height: 40px;background: rgba(245, 247, 250, 1);">
          <th width="20%"> {{ $t('original.Test_scale') }}</th>
          <th width="20%"> {{ $t('original.languages106') }}</th>
          <th width="20%"> {{ $t('original.languages107') }}</th>
          <th width="20%">均分</th>
          <th width="20%"> {{ $t('original.languages73') }}</th>
        </tr>
        <tr v-for="item in PaperList" :key="item.index" style="height: 40px; line-height: 40px; text-align: center;">
          <td width="20%">{{ item.PaperName }}</td>
          <td width="20%">{{ item.PaperScoreR }}</td>
          <td width="20%">{{ item.PaperScoreS }}</td>
          <td width="20%">{{ item.PaperScoreA }}</td>
          <td width="20%"> <span style="color: rgba(0, 136, 255, 1);padding: 20px;cursor: pointer;"  @click="openReport(item.PaperResultID)"> {{ $t('original.languages174') }}</span>
           </td>
        </tr>
      </table>
    </el-dialog>

    <!-- 通知弹窗 -->
        <el-dialog title="通知" :visible.sync="noticedialogVisible" width="500px">
          <el-form @submit.native.prevent class="noticedialogVisible">
            <el-form-item label="短信内容">
              <el-input type="textarea" v-model="message" placeholder="请输入需要发送的短信内容"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="noticedialogVisible=false">取 消</el-button>
            <el-button type="primary" @click="sendnotice" :loading="noticeload">确 定</el-button>
          </span>
        </el-dialog>

    <!-- 心理普测访谈记录表添加 -->
    <el-dialog close="dialogs" :title="$t('original.languages169')" :before-close="whandleClose" :visible.sync="interviewVisible" center>
      <el-form :model="fieldObj" ref="ruleForm" label-width="180px" class="demo-ruleForm">
        <h2 style="margin-left: 15px;">访谈人信息</h2>
        <el-form-item :label="$t('original.languages108')">
          <el-input :disabled="true" v-model="Paperhead.Remark" placeholder="请输入..." show-word-limit></el-input>
        </el-form-item>
        <!-- <el-form-item label="学号" style="margin-top: 10px;">
          <el-input :disabled="true" v-model="Paperhead.UserID" placeholder="请输入..." show-word-limit></el-input>
        </el-form-item> -->
        <el-form-item label="访谈时间" style="margin-top:10px">
          <el-date-picker :picker-options="pickerOptions" v-model="value1" type="datetime" placeholder="选择日期"
             value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <h2 style="margin-left: 15px;">访谈前风险等级</h2>
          <span style="margin-left: 15px;font-size: 16px;" :class="Lv == '轻度' ? 'mild' : Lv == '中度' ? 'moderate' : Lv == '重度' ? 'severe' : Lv == '良好' ? 'well' : ''">{{ Lv }}</span>
        <h2 style="margin-left: 20px;">学生信息</h2>
        <ul style="width: 98%;height: 40px;background-color: #befae6;margin-left: 2%;margin-top: 10px;">
          <li style="float: left;width: 25%;line-height: 40px;text-indent:20px;">姓名：{{ Paperhead.Name }}</li>
          <li style="float: left;width: 15%;line-height: 40px;text-indent:20px;">性别：{{ Paperhead.Sex }}</li>
          <li style="float: left;width: 15%;line-height: 40px;text-indent:20px;">年龄：{{ Paperhead.Age }}</li>
          <li style="float: left;width: 45%;line-height: 40px;text-indent:20px;">学号：{{ Paperhead.UserID }}</li>
        </ul>
        <el-form-item class="ft1" label="访谈状态" style="margin-top:10px">
          <el-radio-group v-model="InterviewStatus" style="margin-left: 20px;">
            <el-radio label="4">准时</el-radio>
            <el-radio label="5">迟到</el-radio>
            <el-radio label="6">未来访</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-for="(item, index) in fieldArray" :key="index" :class="item.HtmlElements">
          <h2 v-if="item.HtmlElements === '标题'">{{ item.ShowName }}</h2>
          <template v-if="item.HtmlElements === '文本域'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input type="textarea" maxlength="1000" v-model="item.FormValue" placeholder="请输入..." show-word-limit>
              </el-input>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '填空题'">
            <el-form-item :label="item.ShowName" class="ccc" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input maxlength="1000" type="textarea" rows="4" :placeholder="item.desc" v-model="item.FormValue"
                show-word-limit></el-input>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '时间选择'">
            <el-form-item :prop="item.ShowName" :label="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-date-picker v-model="item.FormValue" :name="item.ShowName" type="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="item.desc"></el-date-picker>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '下拉选择'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-select v-model="item.FormValue" :placeholder="item.describe">
                <el-option v-for="items in item.list" :key="items.name" :label="items.name" :value="items.value">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '单选题'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <template v-for="child in item.Bobbies" style="margin-top: -20px;">
                <el-radio v-bind:style="{ color: child.FontColor }" v-model="item.FormValue" :label="child.Value">{{
                  child.Name }}</el-radio>
              </template>
              <el-form-item style="display: inline-block;margin-left: 20px;" v-for="itmes in item.Bobbies"
                :key="itmes.index">
                <el-input style="width: 700px;min-height: 80px;" type="textarea" maxlength="1000" v-if="itmes.Display"
                  v-model="itmes.FormValue" placeholder="请输入..." show-word-limit></el-input>
              </el-form-item>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '多选题'" class="复选框">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-checkbox-group v-model="item.FormValue" style="display: inline-block;">
                <template v-for="child in item.hobbies">
                  <el-checkbox :label="child.name"></el-checkbox>
                </template>
              </el-checkbox-group>
              <el-form-item label="其他" v-if="item.duo" style="display: inline-block;margin-left: 20px;">
                <el-input v-model="item.FormValue" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form-item>
          </template>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(interviewVisible = false), wppgai()"> {{ $t('original.languages164') }}</el-button>
        <el-button v-if="SaveFlg == 1" type="primary" @click="submitForm(0)">提交</el-button>
        <el-button v-if="SaveFlg == 1" type="primary" @click="submitForm(1)">临时保存 </el-button>
      </span>
    </el-dialog>
    <el-dialog close="dialogs" :title="$t('original.languages169')" :visible.sync="interviewVisible2"
      :before-close="handleClose" width="70%" center class="interviewVisible">
      <div style="text-align: center;">
        <el-button v-if="entity == '辅导员' && zhungtai == '已跟进'" type="primary" style="float: right;"
          @click="wdisabled = false">{{ $t('original.languages57') }}</el-button>
      </div>
      <el-form :model="fieldObj" ref="ruleForm" label-width="180px" class="demo-ruleForm">
        <el-form-item :label="$t('original.languages108')">
          <el-input  v-model="lookRemark" :placeholder="$t('original.languages4')" show-word-limit
            :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="访谈时间" style="margin-top:10px">
          <el-date-picker :picker-options="pickerOptions" v-model="value1" type="date" :disabled="wdisabled"
            :placeholder="$t('original.languages3')" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <p style="margin-left: 14px;line-height: 40px;font-size: 16px;">访谈状态：{{ftzt}}</p>
        <h2 style="margin-left: 15px;">访谈前风险等级</h2>

        <span style="margin-left: 15px;font-size: 16px;" :class="Lv == '轻度' ? 'mild' : Lv == '中度' ? 'moderate' : Lv == '重度' ? 'severe' : Lv == '良好' ? 'well' : ''">{{ Lv }}</span>
        <h2 style="margin-left: 20px;">学生信息</h2>
        <ul style="width: 98%;height: 40px;background-color: #befae6;margin-left: 2%;margin-top: 10px;">
          <li style="float: left;width: 25%;line-height: 40px;text-indent:20px;">姓名：{{ Paperhead.Name }}</li>
          <li style="float: left;width: 15%;line-height: 40px;text-indent:20px;">性别：{{ Paperhead.Sex }}</li>
          <li style="float: left;width: 15%;line-height: 40px;text-indent:20px;">年龄：{{ Paperhead.Age }}</li>
          <li style="float: left;width: 45%;line-height: 40px;text-indent:20px;">学号：{{ Paperhead.UserID }}</li>
        </ul>
        <div v-for="(item, index) in fieldArray" :key="index" :class="item.HtmlElements">
          <h2 v-if="item.HtmlElements === '标题'">{{ item.ShowName }}</h2>
          <template v-if="item.HtmlElements === '文本域'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input type="textarea" maxlength="1000" v-model="item.FormValue" :disabled="wdisabled" placeholder="请输入..." show-word-limit></el-input>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '填空题'">
            <el-form-item :label="item.ShowName" class="ccc" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input type="textarea" maxlength="1000" rows="4" :disabled="wdisabled" :placeholder="item.desc"
                v-model="item.FormValue" show-word-limit></el-input>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '时间选择'">
            <el-form-item :prop="item.ShowName" :label="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-date-picker :disabled="wdisabled" v-model="item.FormValue" :name="item.ShowName" type="date"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="item.desc"></el-date-picker>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '下拉选择'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-select v-model="item.FormValue" :placeholder="item.describe">
                <el-option :disabled="wdisabled" v-for="items in item.list" :key="items.name" :label="items.name" :value="items.value">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '单选题'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <template v-for="child in item.Bobbies">
                <el-radio :disabled="wdisabled" v-bind:style="{ color: child.FontColor }" v-model="item.FormValue"
                  :label="child.Value">{{ child.Name }}</el-radio>
              </template>
              <el-form-item style="display: inline-block;margin-left: 20px;" v-for="itmes in item.Bobbies"
                :key="itmes.index">
                <el-input type="textarea" style="width: 700px;min-height: 80px;" maxlength="1000" :disabled="wdisabled"
                  v-if="itmes.Display" v-model="itmes.FormValue" placeholder="请输入..." show-word-limit></el-input>
              </el-form-item>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '多选题'" class="复选框">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change', }] : []">
              <el-checkbox-group :disabled="wdisabled" v-model="item.FormValue" style="display: inline-block;">
                <template v-for="child in item.hobbies">
                  <el-checkbox :label="child.name"></el-checkbox>
                </template>
              </el-checkbox-group>
              <el-form-item label="其他" v-if="item.duo" style="display: inline-block;margin-left: 20px;">
                <el-input :disabled="wdisabled" v-model="item.FormValue" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form-item>
          </template>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(interviewVisible2 = false), wppgai()"> {{ $t('original.cancel') }}</el-button>
        <el-button v-if="!wdisabled" type="primary" @click="submitForm2()">{{ $t('original.languages57') }}</el-button>
      </span>
    </el-dialog>

    <el-container>
      <el-header class="el-header" v-if="zhedie">
        <div class="boxs">
          <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline"
            style="background-color: #fff;">
            <el-form-item :label="$t('original.languages110')">
              <el-input :placeholder="$t('original.languages111')" v-model="ruleForm.UserID"></el-input>
            </el-form-item>
            <el-form-item :label="$t('original.languages112')">
              <el-select v-model="ruleForm.General" :placeholder="$t('original.languages3')">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('original.Release_theme')">
              <el-select v-model="ruleForm.PublishSubject" :placeholder="$t('original.Release_theme')">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in GetSubjectPublishList" :key="item.PublishID" :label="item.PublishSubject" :value="item.PublishID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('original.languages55')">
              <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="ruleForm.DeptID"  filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable></el-cascader>
            </el-form-item>
            <el-form-item label="访谈来源">
              <el-select v-model="ruleForm.Source" :placeholder="$t('original.languages3')">
                <el-option label="全部" value="-1">全部</el-option>
                <el-option label="测评结果" value="1">测评结果</el-option>
                <el-option label="手动加入" value="2">手动加入</el-option>
                <!-- <el-option label="随机生成" value="3">随机生成</el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('original.languages118')">
              <el-select v-model="ruleForm.state" :placeholder="$t('original.languages3')">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('original.languages119')">
              <el-select v-model="ruleForm.interview" :placeholder="$t('original.languages3')">
                <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('original.languages120')">
              <el-select v-model="ruleForm.progress" :placeholder="$t('original.languages3')">
                <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item v-if="this.Global.pdroleid(1063) || this.Global.pdroleid(1089)" class="csok" label="单位类型"  style="width: 600px;">
              <el-checkbox style="float: left;margin-right: 20px;" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              <el-checkbox-group :min="1" v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-checkbox label="selDepartment" key="selDepartment">培养单位</el-checkbox>
                  <el-checkbox label="selTrain" key="selTrain">管理单位</el-checkbox>
                <el-checkbox label="selTeach" key="selTeach">集中教学单位</el-checkbox>
              </el-checkbox-group>
            </el-form-item> -->
            <el-form-item v-if="this.Global.pdroleid(1063) || this.Global.pdroleid(1089)" class="csok" label="单位类型"  style="width: 600px;">
              <el-radio-group v-model="ruleForm.unitType">
                <el-radio label="0">默认</el-radio>
                <el-radio label="1">集中教学单位</el-radio>
                <el-radio label="2">管理单位</el-radio>
                <el-radio label="3">培养单位</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="noticedialogVisible=true"> 编辑短信</el-button>
              <el-button type="primary" @click="zhedies">{{ $t('original.languages121') }}</el-button>
              <!-- <el-button type="primary" @click="wjsb"> {{ $t('original.languages122') }}</el-button> -->
              <el-button type="primary" @click="ExportTableList(1)"> {{ $t('original.languages154') }}</el-button>
              <el-popover v-if="!c3" placement="top" width="160" v-model="visible">
                <p>{{ $t('original.languages123') }}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible = false"> {{ $t('original.cancel') }}</el-button>
                  <el-button type="primary" size="mini" @click="AddCombineResultStochastic"> {{$t('original.languages59')}}</el-button>
                </div>
                <!-- <el-button type="primary" slot="reference"> {{ $t('original.languages124') }}</el-button> -->
              </el-popover>
              <!-- <el-button v-if="!c3" type="primary" @click="Randomfun"> {{ $t('original.languages125') }}</el-button> -->
              <el-button type="primary" @click="resetForm()">{{ $t('original.reset') }}</el-button>
              <el-button type="primary" :disabled='xaukm' @click="GettableList(1),sousfun()"> {{$t('original.search')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-header>
      <el-header v-if="!zhedie">
        <el-button type="primary" @click="zhankai"> {{ $t('original.languages126') }}</el-button>
      </el-header>
      <el-main class="el-main">
        <el-row>
          <el-col :span="22">
            <span style="padding: 5px;color: rgba(242, 75, 78, 1);background-color: rgba(242, 75, 78, 0.2);">
              <span style="margin-left: 20px;"> {{ $t('original.languages127') }}：{{ testcount.one }}/{{ interviewcount.one }}</span>
              <span style="margin-left: 20px;"> {{ $t('original.languages128') }}：{{ testcount.six }}/{{ interviewcount.six}}</span>
              <span style="margin-left: 20px;"> {{ $t('original.languages129') }}：{{ testcount.tow }}/{{interviewcount.tow}}</span>
              <span style="margin-left: 20px;"> {{ $t('original.languages130') }}：{{ testcount.three }}/{{ interviewcount.three }}</span>
              <span style="margin-left: 20px;"> {{ $t('original.languages131') }}：{{ testcount.four }}/{{ interviewcount.four }}</span>
              <span style="margin-left: 20px;"> {{ $t('original.languages132') }}：{{ testcount.five }}/{{ interviewcount.five }}</span>
            </span>
            <span style="padding: 5px;color: rgba(242, 75, 78, 1);background-color: rgba(255, 238, 222, 1);margin-left:20px">
              <span style="margin-left:30px" v-for="(item,i) in count2" :key="i">{{item.key}} : {{item.count}}</span>
            </span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-table v-loading="loading" :data="tableList" stripe ref="singleTable" highlight-current-row
              @current-change="handleCurrentChange" style="width: 100%;" @sort-change="onSortChange">
              <el-table-column :label="$t('original.The_serial_number')" align="left" width="60px"><template slot-scope="scope" center>
                {{ (Number(ruleForm.PageIndex)  - 1) * 10 + Number(scope.$index)  + 1 }}
              </template>
              </el-table-column>
              <el-table-column property="UserID" :label="$t('original.languages79')" :center="true"></el-table-column>
              <el-table-column property="RealName" :label="$t('original.name')"></el-table-column>
              <el-table-column property="Sex" :label="$t('original.gender')" sortable="custom" :sort-orders="['ascending', 'descending']"> </el-table-column>
              <el-table-column property="Degree" :label="$t('original.languages175')" sortable="custom" :sort-orders="['ascending', 'descending']"> </el-table-column>
              <el-table-column property="DeptName" :label="$t('original.languages55')" sortable="custom" :sort-orders="['ascending', 'descending']"> </el-table-column>
              <el-table-column property="PublishSubject" :label="$t('original.Release_theme')" width="210px" sortable="custom" :sort-orders="['ascending', 'descending']"></el-table-column>
              <el-table-column property="resultSort" align="center" sortable="custom" :sort-orders="['ascending', 'descending']" :label="$t('original.languages112')">
                <template slot-scope="scope" center>
                  <span :class="scope.row.Result == '轻度' ? 'mild' : scope.row.Result == '中度' ? 'moderate' : scope.row.Result == '重度' ? 'severe' : scope.row.Result == '良好' ? 'well' : ''">{{ scope.row.Result }}</span>
                </template>
              </el-table-column>
              <!-- --- -->
              <el-table-column property="interviewConditionNameSort" align="center" sortable="custom" :sort-orders="['ascending', 'descending']" :label="$t('original.languages119')">
                <template slot-scope="scope" center>
                  <span :class="scope.row.InterviewConditionName == '轻度' ? 'mild' : scope.row.InterviewConditionName == '中度' ? 'moderate' : scope.row.InterviewConditionName == '重度' ? 'severe' : scope.row.InterviewConditionName == '良好' ? 'well' : scope.row.InterviewConditionName == '严重且紧急' ? 'urgency' : ''">
                    {{ scope.row.InterviewConditionName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column property="" :label="$t('original.languages133')">
                <template slot-scope="scope" center>
                  <el-popover v-if="scope.row.Suggest != '-'" placement="top-start" title="建议" width="200" trigger="hover" :content="scope.row.ResultDetailZX">
                    <div slot="reference">
                      <span :class="scope.row.Suggest == '轻度' || scope.row.Suggest == '适当关注' ? 'mild' : scope.row.Suggest == '中度' || scope.row.Suggest == '重点关注' ? 'moderate' : scope.row.Suggest == '重度' || scope.row.Suggest == '密切陪护' ? 'severe' : scope.row.Suggest == '良好' || scope.row.Suggest == '正常交流' ? 'well' : scope.row.Suggest == '严密守护' ? 'urgency' : ''">
                        {{ scope.row.Suggest }}
                      </span>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column v-if="entity !== '辅导员'" label="普测报告" align="center">
                <template slot-scope="scope">
                  <span @click="OpenCenterDialogVisible(scope.row)" :style="scope.row.Percentage != 0 ? 'padding:20px; color: rgba(36, 153, 255, 1); cursor:pointer;' : 'padding:20px; color: rgba(166, 166, 166, 1); cursor:pointer;'">查看</span>
                </template>
              </el-table-column>
              <el-table-column Percentage :label="$t('original.languages120')">
                <template slot-scope="scope" center>
                  <el-progress :text-inside="true" :stroke-width="26" :percentage="Number(scope.row.Percentage)"></el-progress>
                </template>
              </el-table-column>
              <el-table-column property="Source" label="访谈来源"></el-table-column>
              <el-table-column property="State"  label="访谈状态" width="120" sortable="custom" :sort-orders="['ascending', 'descending']"></el-table-column>

              <el-table-column label="访谈操作" width="200">
                <template slot-scope="scope" align="center">
                  <span v-if="(pdroleid(1063) || pdroleid(1089)) && ((scope.row.Result=='中度' && scope.row.State == '已预约') || (scope.row.Result == '重度' && validFlag == '0' && (scope.row.State == '未来访' || scope.row.State == '需要访谈'))) " style="padding:20px;color: rgba(36, 153, 255, 1);cursor: pointer;" @click="openInterviewVisible(scope.row)">访谈跟进</span>
                  <span  v-if="(scope.row.State == '已跟进(迟到)' || scope.row.State == '已跟进(准时)' || scope.row.State == '已上报' || scope.row.State == '未上报') && (pdroleid(1057) || pdroleid(1067) || pdroleid(1068) || pdroleid(1069) || pdroleid(1070) || pdroleid(1063) || pdroleid(1089))" style="padding:20px;color: rgba(36, 153, 255, 1);margin-left: 8px;cursor: pointer;"  @click="openInterviewFormVisible(scope.row)">查看跟进</span>
                  <span v-if="((scope.row.c3 == false && scope.row.State == '无需访谈' && (scope.row.Result == '轻度' || scope.row.Result == '良好')) || scope.row.c1 == '4') && scope.row.Source != '手动加入'" style="padding:20px;color: rgba(36, 153, 255, 1);margin-left:8px;cursor:pointer;" @click="AddCombineResult(scope.row)">加入访谈</span>
                  <span v-if="scope.row.c1 == '2' && scope.row.InterviewConditionName == '-' && scope.row.Source == '手动加入' && scope.row.c3 == false" style="padding:20px;color:rgba(36, 153, 255, 1);margin-left:8px;cursor:pointer;" @click="DeleteCombineResult(scope.row)">取消</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination style="margin-top:10px;float: right;" background layout="total,prev,pager,next,jumper"
              :page-size="10" :total="AllCount" @current-change="current_change" :hide-on-single-page="wpppd" :current-page.sync="currentPage1">
            </el-pagination>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

  </div>
</template>
<script>
export default {
  mounted() { },
  data() {
    return {
      noticedialogVisible:false,
      message:'',
      noticeload:false,
      count2:[],
      checkAll:true,
      checkedCities:['selDepartment','selTeach','selTrain'],
      sexSort:'',//用户编号排序
      degreeSort:'',//学历排序
      deptIDSort:'',//部门排序
      publishSubjectSort:'',//发布主题排序
      resultSort:'',//普测后等级
      interviewConditionNameSort:'',//访谈后等级
      interviewStatusSort:'',//访谈状态排序
      RoleID:'',
      currentPage1:1,
      pageIndex:1,
      Lv:'',
      lookRemark:'',
      ftzt:'',
      InterviewStatus:'4',
      entity:'',
      xaukm:false,
      zhungtai:'',
      validFlag:'',
      visible:false,
      c3:false,//判断是否访谈
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      entity:sessionStorage.getItem('entity'),
      zhedie:true,
      chongzhiDeptID:'',
      Determine_random:true,//判断是否点击随机访谈
      gysjhxss:[],//分页后端要的总数据
      gysjhx:[],//分页后端要的十条数据
      listCountS:[],
      Random:0,
      SaveFlg:1,
      data:[],
      bans:false,
      optionsnew:[],
      GetSubjectPublishList:[],
      wdisabled:true,
      VsitorNameList:[],
      value1:'',
      wUserID:'',
      fieldObj:{},
      fieldArray:[], //表单字段集合
      loading:true,
      wpppd:true,
      testcount:{one:0,tow:0,three:0,four:0,five:0,six:0},
      interviewcount:{one:0,tow:0,three:0,four:0,five:0,six:0},
      tableList:[],
      PaperList:[],
      Paperhead:{
        Name:'',
        Sex:'',
        DeptName:'',
        UserID:'',
        Result:'',
        PublishID:'',
        Remark:'',
        Age:'',
      },
      interviewfrom: {
        val1:'',
        val2:'',
        val3:[],
        val4:'',
        val5:[],
        val6:'',
        val7:[],
        val8:[],
        val9:'',
        val10:'',
        val11:'',
        val12:[],
        val13:'',
        val14:'',
        val15:'',
        val16:[],
        val17:'',
        val18:'',
        val19:'',
        val20:'',
        val21:'',
      },
      centerDialogVisible:false, //查看测评量表
      interviewVisible:false, //访谈跟进
      interviewVisible2:false, //访谈跟进查看修改
      ruleForm:{
        UserID:'',
        General:'',
        DeptID:'',
        PublishSubject:'',
        state:'',
        interview:'',
        progress:'',
        Source:'-1',
        PageIndex:1,
        unitType:'0',
      },
      options: [
        {value:'良好',label:'良好'},
        {value:'轻度',label:'轻度'},
        {value:'中度',label:'中度'},
        {value:'重度',label:'重度'},
      ],
      options2: [
        {value:'无需访谈',label:'无需访谈'},
        {value:'需要访谈',label:'需要访谈'},
        {value:'已预约', label:'已预约'},
        {value:'已跟进(准时)',label:'已跟进(准时)'},
        {value:'已跟进(迟到)',label:'已跟进(迟到)'},
        {value:'未来访',label:'未来访'},
      ],
      options3: [
        {value:'良好',label:'良好' },
        {value:'轻度',label:'轻度' },
        {value:'中度',label:'中度' },
        {value:'重度',label:'重度' },
        {value:'无法确定',label:'无法确定' },
        {value:'严重且紧急',label:'严重且紧急' },
      ],
      options4: [
        {value:'1',label:'已完成'},
        {value:'0',label:'未完成'},
      ],
      PageInfo: { CurrentIndex: 0, PageSize: 10, PageIndex: 1, TotleCount: 0, TotlePageCount: 0 },
      AllCount: -1,
      firstFlag:true //首次进入页面
    };
  },
  mounted: function () {
    

    if(localStorage.getItem('EmphasisClarification')){
      this.ruleForm = JSON.parse(localStorage.getItem('EmphasisClarification'));
    }
    this.RoleID = sessionStorage.getItem('RoleID');
    this.entity = sessionStorage.getItem('entity');
    this.GetSubjectPublish();
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID:'',content:''}).then((res) => {
      if (res.Data) {
        this.optionsnew = res.Data;
        this.ruleForm.DeptID = res.Data[0].DeptID;
        this.chongzhiDeptID = res.Data[0].DeptID;
      }
    });
  },
  methods: {
    sousfun(){localStorage.setItem('EmphasisClarification',JSON.stringify(this.ruleForm) )},
    pdroleid(id) {
      var RoleID = sessionStorage.getItem('RoleID')
      if (RoleID.indexOf(id) !== -1) {
        return true
      } else {
        return false
      }
    },
    onSortChange(column){
     if(column.prop == 'Sex'){
      this.sexSort = column.order;
      this.degreeSort = '';
      this.deptIDSort = '';
      this.publishSubjectSort = '';
      this.interviewStatusSort = '';
      this.resultSort = '';
      this.interviewConditionNameSort = '';
     }else if(column.prop == 'Degree'){
      this.degreeSort = column.order;
      this.sexSort = '';
      this.deptIDSort = '';
      this.publishSubjectSort = '';
      this.interviewStatusSort = '';
      this.resultSort = '';
      this.interviewConditionNameSort = '';
     }else if(column.prop == 'DeptName'){
      this.deptIDSort = column.order;
      this.sexSort = '';
      this.degreeSort = '';
      this.publishSubjectSort = '';
      this.interviewStatusSort = '';
      this.resultSort = '';
      this.interviewConditionNameSort = '';
     }else if(column.prop == 'PublishSubject'){
      this.publishSubjectSort = column.order;

      this.sexSort = '';
      this.degreeSort = '';
      this.deptIDSort = '';
      this.interviewStatusSort = '';
      this.resultSort = '';
      this.interviewConditionNameSort = '';

      
     }else if(column.prop == 'State'){
      this.interviewStatusSort = column.order;
      this.sexSort = '';
      this.degreeSort = '';
      this.deptIDSort = '';
      this.publishSubjectSort = '';
      this.resultSort = '';
      this.interviewConditionNameSort = '';
     }else if(column.prop == 'resultSort'){
      this.interviewStatusSort = '';
      this.sexSort = '';
      this.degreeSort = '';
      this.deptIDSort = '';
      this.publishSubjectSort = '';
      this.resultSort = column.order;
      this.interviewConditionNameSort = '';
     }else if(column.prop == 'interviewConditionNameSort'){
      this.interviewStatusSort = '';
      this.sexSort = '';
      this.degreeSort = '';
      this.deptIDSort = '';
      this.publishSubjectSort = '';
      this.resultSort = '';
      this.interviewConditionNameSort = column.order;
     }else{
      this.interviewStatusSort = '';
      this.sexSort = '';
      this.degreeSort = '';
      this.deptIDSort = '';
      this.publishSubjectSort = '';
     }
    this.GettableList();
   },
   handleCheckAllChange(val) {
      if (val) {
        this.checkedCities = ['selDepartment','selTeach','selTrain'];
        this.isIndeterminate = false;
      } else {
        this.checkedCities = ['selDepartment', 'selTeach', 'selTrain'];
        this.checkAll = true;
      }
    },
    handleCheckedCitiesChange(value) {
      this.checkedCities = value;
      if (value.length >= 3) {
        this.isIndeterminate = false;
      } else {
        this.isIndeterminate = true;
      }
    },
    wjsb() {
      this.$Http_Post('EmphasisClarification/VerifyReported', { pageSize: this.PageInfo.PageSize, pageIndex: this.ruleForm.PageIndex, UserID: this.ruleForm.UserID, General: this.ruleForm.General, PublishSubject: this.ruleForm.PublishSubject, state: this.ruleForm.state, interview: this.ruleForm.interview, progress: this.ruleForm.progress, DeptID: this.ruleForm.DeptID, Source: this.ruleForm.Source, Random: this.Random }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    handleClose(done) {
      this.$confirm(this.$t('original.languages60')).then(_ => {
        done();
        this.Paperhead.Remark = ''
      })
      .catch(_ => {
      });
    },
    whandleClose(done) {
      this.$confirm(this.$t('original.languages60')).then(_ => {
        done();
        this.Paperhead.Remark = ''
      })
      .catch(_ => {
      });
    },
    zhedies() {
      this.zhedie = false;
    },
    zhankai() {
      this.zhedie = true;
    },
    Randomfun() {
      this.loading = true;
      this.Determine_random = false;
      this.Random = 1;
      this.ruleForm.UserID = '';
      this.ruleForm.General = '';
      this.ruleForm.state = '';
      this.ruleForm.interview = '';
      this.ruleForm.progress = '';
      this.ruleForm.Source = '-1';
      this.RandomInterviews();
    },
    RandomInterviews() {
      this.$Http_Post('/EmphasisClarification/RandomInterviews', {PublishID: this.ruleForm.PublishSubject,UserIDList: this.gysjhx,UserIDListTwo: this.GetTableList,DeptID: this.ruleForm.DeptID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableList = res.Data.list1;
          
          this.GetTableList = res.Data.listCountS;
          this.loading = false;
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }
          this.AllCount = res.Counts;
        } else {
          this.loading = false;
          this.Global.request_failure(res.Message);
        }
      });
    },
    AddCombineResult(row) {
      this.$Http_Post('/EmphasisClarification/AddCombineResult',{UserID: row.UserID,PublishID: row.PublishID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    DeleteCombineResult(row) {
      this.$Http_Post('/EmphasisClarification/DeleteCombineResult', {UserID: row.UserID,PublishID: row.PublishID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    AddCombineResultStochastic() {
      this.visible = false;
      this.$Http_Post('/EmphasisClarification/AddCombineResultStochastic', { UserIDList: this.GetTableList, PublishID: this.ruleForm.PublishSubject, }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
          this.Determine_random = true;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    Selected_to_shut_dow(dt) {
      this.ruleForm.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.optionsnew[0];
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children
          );
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
    getVsitorNameList(query) {
      if (query !== '') {
        this.loadingstart = true;
        this.$Http_Post('ConsultSubscribe/GetBlacklistNameList', {Query:query}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingstart = false;
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },

    selectVsitorName() {
      for (let index = 0; index < this.VsitorNameList.length; index++) {
        if (this.VsitorNameList[index].UserID == this.wUserID) {
          this.addInformationShow = true;
          this.DeptName = this.VsitorNameList[index].DeptName;
        }
      }
    },

    getFieldData() {
      let response = this.fieldArray;
      for (let i = 0; i < response.length; i++) {
        let item = response[i];
        if (item.HtmlElements === '复选框') {
          this.$set(this.fieldObj, item.ShowName, []);
        } else {
          this.$set(this.fieldObj, item.ShowName, item.showValue);
        }
      }
    },

    submitForm(temporaryFlag) {//提交验证
      this.interviewVisible = false;
      this.$Http_Post('CrisisWarning/AddingConfigForm', {userid: this.Paperhead.UserID,createtime: this.value1,form: this.fieldArray,TableName: '新生心理普测访谈记录表',PublishID: this.Paperhead.PublishID,Modify: false,Remark: this.Paperhead.Remark,InterviewStatus: this.InterviewStatus,temporaryFlag:temporaryFlag}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Paperhead.Remark = ''
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    submitForm2(formName) {
      //提交修改
      (this.interviewVisible = false),
        this.$Http_Post('CrisisWarning/AddingConfigForm', {userid:this.Paperhead.UserID,createtime:this.value1,form:this.fieldArray, TableName:'新生心理普测访谈记录表',PublishID:this.Paperhead.PublishID,Modify:true,Remark:this.Paperhead.Remark}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.interviewVisible2 = false;
            this.Global.request_successful(res.Message);
            this.GettableList();
            this.Paperhead.Remark = '';
          }
        });
    },
    wppgai() {
      this.Paperhead.Remark = '';
      (this.wdisabled = true((this.interviewfrom.val1 = ''))),
      (this.interviewfrom.val2  = ''),
      (this.interviewfrom.val3  = []),
      (this.interviewfrom.val4  = ''),
      (this.interviewfrom.val5  = []),
      (this.interviewfrom.val6  = ''),
      (this.interviewfrom.val7  = []),
      (this.interviewfrom.val8  = []),
      (this.interviewfrom.val9  = ''),
      (this.interviewfrom.val10 = ''),
      (this.interviewfrom.val11 = ''),
      (this.interviewfrom.val12 = []),
      (this.interviewfrom.val13 = ''),
      (this.interviewfrom.val14 = ''),
      (this.interviewfrom.val15 = ''),
      (this.interviewfrom.val16 = []),
      (this.interviewfrom.val17 = ''),
      (this.interviewfrom.val18 = ''),
      (this.interviewfrom.val19 = ''),
      (this.interviewfrom.val20 = ''),
      (this.interviewfrom.val21 = '');
    },
    resetForm() {
      this.currentPage1 = 1;
      this.Determine_random = true;
      this.ruleForm.UserID = '';
      this.ruleForm.General = '';
      this.ruleForm.PublishSubject = '';
      this.ruleForm.state = '';
      this.ruleForm.interview = '';
      this.ruleForm.progress = '';
      this.ruleForm.DeptID = this.chongzhiDeptID;
      this.ruleForm.Source = '-1';
      this.c3 = false;
      this.ruleForm.PageIndex = 1;
      //this.GettableList();
    },
    openReport(a) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      });
      window.open(routeData.href, '_blank');
    },
    openInterviewFormVisible(row) {//查看修改
      this.zhungtai = row.State;
      this.fieldArray = [];
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Sex = row.Sex;
      this.Paperhead.Age = row.Age;
      this.Paperhead.Result = row.Result;
      this.Paperhead.UserID = row.UserID;
      this.Paperhead.PublishID = row.PublishID;
      this.ftzt = row.State;
      this.Lv = row.Result;
      this.Paperhead.Remark = JSON.parse(localStorage.getItem('userInfo')).UserName;
      this.$Http_Post('CrisisWarning/GetFormView', { TableName: '新生心理普测访谈记录表', PublishID: this.Paperhead.PublishID, UserID: this.Paperhead.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.fieldArray = res.Data.sys_Forms;
          this.value1 = res.Data.createtime;
          this.lookRemark = res.Data.Remark;
          // this.Paperhead.Remark = res.Data.Remark;
          this.interviewVisible2 = true;
        }
      });
    },
    openInterviewVisible(row) {//访谈跟进
      this.fieldArray = [];
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Sex = row.Sex;
      this.Paperhead.Result = row.Result;
      this.Paperhead.UserID = row.UserID;
      this.Paperhead.PublishID = row.PublishID;
      this.Lv = row.Result;
      // this.value1 = row.StartTime;
      this.Paperhead.Age = row.Age;
      this.Paperhead.Remark = JSON.parse(localStorage.getItem('userInfo')).UserName;

      this.$Http_Post('CrisisWarning/GetFormView', { TableName: '新生心理普测访谈记录表', PublishID: row.PublishID, UserID: row.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if(res.Data.sys_Forms){
            this.fieldArray = res.Data.sys_Forms;
            this.interviewVisible = true;
          }else{
            this.$Http_Post('CrisisWarning/GetPageList',{TableName:'新生心理普测访谈记录表'}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.fieldArray = res.Data.FormConfigurations;
                this.SaveFlg = res.Data.SaveFlg;
                this.interviewVisible = true;
              }
            });
          }
        }
      });
    },

    OpenCenterDialogVisible(row) {
      if (row.Percentage != 0) {
        this.centerDialogVisible = true;
        this.Paperhead.Name = row.RealName;
        this.Paperhead.Sex = row.Sex;
        this.Paperhead.DeptName = row.DeptName;
        this.Paperhead.UserID = row.UserID;
        this.$Http_Post('EmphasisClarification/GetPaperList', {UserID:row.UserID,PublishID:row.PublishID}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.PaperList = res.Data;
          }
        });
      }
    },

    GetSubjectPublish() {
      this.$Http_Post('EmphasisClarification/GetSubjectPublish').then((res) => {
        this.loading=false;
        if (res.Code == 200 || res.Code == 0) {
          this.GetSubjectPublishList = res.Data;
          this.ruleForm.PublishSubject = res.Data[0].PublishID
          if(!this.firstFlag){
            this.GettableList();
          }else{
            this.firstFlag=false;
          }
        }
      });
    },

    ExportTableList() {
      this.daochu = true;
      this.$Http_Post('EmphasisClarification/ExportTableList', {UserID: this.ruleForm.UserID,General: this.ruleForm.General,PublishSubject: this.ruleForm.PublishSubject,state: this.ruleForm.state,interview: this.ruleForm.interview,progress: this.ruleForm.progress,DeptID: this.ruleForm.DeptID,Source: this.ruleForm.Source,unitType:this.ruleForm.unitType}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.daochu = false;
          this.Global.request_successful(res.Message);
          window.location.href = res.Data;
        } else {
          this.daochu = false;
          this.Global.request_failure(res.Message);
        }
      });
    },

    sendnotice(){
      this.smsFlag=1;
      this.GettableList(1)
    },
    
    GettableList(a) {
      this.xaukm = true;
      this.testcount = {one:0,tow:0,three:0,four:0,five:0,six:0};
      this.interviewcount = {one:0,tow:0,three:0,four:0,five:0,six:0};
      this.loading = true;
      if (a == 1) {
        this.ruleForm.PageIndex = 1;
        this.currentPage1 = 1;
      }
      if(this.smsFlag==1){
        this.noticeload=true;
      }
      this.$Http_Post('EmphasisClarification/GetTableList', {
        pageSize:this.PageInfo.PageSize,
        pageIndex:this.ruleForm.PageIndex,
        UserID:this.ruleForm.UserID,
        General:this.ruleForm.General,
        PublishSubject:this.ruleForm.PublishSubject,
        state:this.ruleForm.state,
        interview:this.ruleForm.interview,
        progress:this.ruleForm.progress,
        DeptID:this.ruleForm.DeptID,
        Source:this.ruleForm.Source,
        Random:this.Random,
        sexSort:this.sexSort,
        degreeSort:this.degreeSort,
        deptIDSort:this.deptIDSort,
        publishSubjectSort:this.publishSubjectSort,
        interviewStatusSort:this.interviewStatusSort,
        selBox:this.checkedCities,resultSort:this.resultSort,
        interviewConditionNameSort:this.interviewConditionNameSort,
        unitType:this.ruleForm.unitType,
        smsFlag:this.smsFlag,
        option:this.ruleForm.PublishSubject?'1':''}).then((res) => {
          this.noticeload=false;
        if (res.Code == 200 || res.Code == 0) {
          this.xaukm = false;
          this.message='';
          this.noticedialogVisible=false;
          this.validFlag=res.Data.validFlag;
          this.count2 = res.Data.count2
          if (res.Data.list1.length > 0) {
            this.c3 = res.Data.list1[0].c3
          }
          this.GetTableList = res.Data.listCountS;
          this.loading = false;
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }
          this.tableList = res.Data.list1;
          this.AllCount = res.Counts;
          let count = res.Data.count;
          // this.ruleForm.PublishSubject = res.Data.PublishID;
          let count1 = res.Data.count1;
          this.testcount.one = 0;
          for (let index = 0; index < count.length; index++) {
            if (count[index].key == '重度') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.tow = parseInt(count[index].count);
            }
            if (count[index].key == '中度') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.three = parseInt(count[index].count);
            }
            if (count[index].key == '轻度') {
              this.testcount.four = parseInt(count[index].count);
            }
            if (count[index].key == '良好') {
              this.testcount.five = parseInt(count[index].count);
            }
            if (count[index].key == '重度且紧急') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.six = parseInt(count[index].count);
            }
          }
          this.interviewcount.one = 0;
          for (let index = 0; index < count1.length; index++) {
            if (count1[index].key == '重度') {
              this.interviewcount.one = this.interviewcount.one + parseInt(count1[index].count);
              this.interviewcount.tow = parseInt(count1[index].count);
            }
            if (count1[index].key == '中度') {
              this.interviewcount.one = this.interviewcount.one + parseInt(count1[index].count);
              this.interviewcount.three = parseInt(count1[index].count);
            }
            if (count1[index].key == '轻度') {
              this.interviewcount.four = parseInt(count1[index].count);
            }
            if (count1[index].key == '良好') {
              this.interviewcount.five = parseInt(count1[index].count);
            }
            if (count1[index].key == '严重且紧急') {
              this.interviewcount.one = this.interviewcount.one + parseInt(count1[index].count);
              this.interviewcount.six = parseInt(count1[index].count);
            }
          }
        } else {
          this.loading = false;
        }
      });
    },
    handleCurrentChange: function (val) {
      this.SelectObj = val;
    },
    current_change: function (currentPage) {
      if (this.Determine_random) {
        this.ruleForm.PageIndex = currentPage;
        this.GettableList();
      } else {
        this.gysjhx = this.GetTableList.slice(
          currentPage * 10 - 10,
          currentPage * 10
        );
        this.RandomInterviews();
      }
    },
  },
};
</script>
<style>
.EmphasisClarification .el-header {height: auto !important;background-color: rgba(255, 255, 255, 1);}
.EmphasisClarification .el-main {margin-top: 20px;background-color: rgba(255, 255, 255, 1);}
input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}
.EmphasisClarification .boxs {background: rgba(245, 247, 250, 1);margin-top: 15px;}
.EmphasisClarification .boxs button {float: right;margin-right: 20px;}
.EmphasisClarification .mild {padding: 0px 15px;background: rgba(29, 154, 255, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(29, 154, 255, 1);}
.EmphasisClarification .moderate {padding: 0px 15px;background: rgba(255, 193, 23, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(255, 193, 23, 1);}
.EmphasisClarification .severe {padding: 0px 15px;background: rgba(255, 141, 26, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(255, 141, 26, 1);}
.EmphasisClarification .well {padding: 0px 15px;background: rgba(21, 191, 109, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(21, 191, 109, 1);}
.EmphasisClarification .urgency {padding: 0px 15px;background: rgba(191, 41, 21, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgb(248, 4, 4);}
.EmphasisClarification .colrowstyle {height: 40px;line-height: 40px;color: rgba(92, 92, 92, 1);background: rgba(245, 247, 250, 1);}
.EmphasisClarification .colrowspanstyle {line-height: 40px;border-top: 1px solid rgba(225, 226, 227, 1);border-left: 1px solid rgba(225, 226, 227, 1);border-right: 1px solid rgba(225, 226, 227, 1);}
.EmphasisClarification .colrowspanbottomstyle {border-bottom: 1px solid rgba(225, 226, 227, 1);}
.EmphasisClarification .noneborder input {border: 0px;}
.EmphasisClarification .bottomborder input {border-bottom: 1px solid rgba(166, 166, 166, 1);}
.EmphasisClarification .el-dialog h2 {padding-top: 14px;margin-bottom: 14px;}
.EmphasisClarification .el-dialog .标题 {width: 100%;}
.EmphasisClarification .el-dialog .el-form>div {margin-left: 14px;}
.EmphasisClarification .el-dialog .输入框 input {width: initial;width: 400px;}
.csok .el-form-item__content {margin-left: 0px !important;width: 410px;}
.EmphasisClarification .el-dialog .el-input__inner {width: initial;}
.EmphasisClarification .el-dialog .el-form-item__label {width: initial !important;display: inline-block;text-align: right;min-width: 90px;text-align: left;width: 132px !important;}
.EmphasisClarification .el-dialog  .el-textarea{width: 162%;}
.EmphasisClarification .el-dialog .el-form-item__content {margin-left: initial !important;display: inline-block;}
.EmphasisClarification .el-textarea__inner {height: 100%;}
.EmphasisClarification .el-dialog .ccc .el-form-item__content {width: 50%;}
.el-dialog .复选框 .el-form-item__label {min-width: 40px !important;}
.EmphasisClarification .el-dialog .el-form-item {margin-bottom: 0px;}
.EmphasisClarification .ft1 .el-form-item__label{width: 50px !important;}
.el-dialog .填空题,.单选题,.时间选择,.文本域 {padding: 6px;border: 1px solid rgb(235, 235, 235);margin-top: 4px;}
.EmphasisClarification .el-form-item { margin-left: 20px;}
.el-table--enable-row-transition .el-table__body td {text-align: center;}
.el-textarea.is-disabled .el-textarea__inner{color: #000;}
.el-input.is-disabled .el-input__inner{color: #000;}
</style>
